/*************************************************/
/* INTERSECTION OBSERVATION                      */
/*************************************************/
import { Counter } from "./counter.js";

export function intersectionObservation() {
    const activeClass = 'in-view',
        targetsClasses = [".banner", ".video-item__player", ".counter", ".fade-effect", ".counter-component__counter", ".media-counter__counter"],
        options = {
            rootMargin: '200px'
        };
    const init = function () {
        let targets = [];
        for (var i = 0; i < targetsClasses.length; i++) {
            var targetElements = document.querySelectorAll(targetsClasses[i]);
            if (targetElements != null) {
                targets.push(...targetElements);
            }
        }
        if ('IntersectionObserver' in window) {
            function handleIntersection(entries) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        if (entry.target.classList.contains('counter')) {
                            new Counter(entry.target);
                        } else if (entry.target.classList.contains('counter-component__counter')) {
                            entry.target.classList.add('border-reveal');
                        } else if (entry.target.classList.contains('media-counter__counter')) {
                            entry.target.classList.add('border-reveal');
                        } else if (entry.target.classList.contains('fade-effect')) {
                            entry.target.classList.add('fade-in');
                        }
                        else {
                            entry.target.classList.add(entry.target.classList[0] + "--" + activeClass);
                            observer.unobserve(entry.target);
                        }
                        observer.unobserve(entry.target);
                    }
                });
            }
            const observer = new IntersectionObserver(handleIntersection, options);
            targets.forEach(target => observer.observe(target));
        } else {
            targets.forEach(target => {
                target.classList.add(target.classList[0] + "--" + activeClass);
            });
        }
    };

    init();
}